export class SimuladorRendaMensalDatas {
    public IDADE_ATUAL: string;
    public IDADE_ADESAO: string;
    public IDADE_RMV: string;
    public DT_INSC_PLANO: string;
    public TEMPO_VINC_PLANO: string;
    public MES_RMV: number;
    public MES_APORTE: number;
}